import React from "react";
import PopupState, { bindHover, bindPopover } from "material-ui-popup-state";
import {
  Button,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Paper,
} from "@mui/material";
import HoverPopover from "material-ui-popup-state/HoverPopover";
import { useNavigate } from "react-router-dom";

const CustomMenuItem = ({ menu }) => {
  const navigate = useNavigate();
  return (
    <MenuItem
      className="text-black w-100 pr-12"
      onClick={() => navigate(menu.url)}
    >
      <ListItemIcon>{menu.icon} </ListItemIcon>
      <ListItemText className="capitalize">{menu.title}</ListItemText>
    </MenuItem>
  );
};

const CustomPopUpMenu = ({ menuItems, popupState }) => {
  return (
    <HoverPopover
      {...bindPopover(popupState)}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      <Paper>
        <MenuList className="w-fit px-2 py-5">
          {menuItems.map((item) => (
            <CustomMenuItem key={item.key} menu={item} />
          ))}
        </MenuList>
      </Paper>
    </HoverPopover>
  );
};

export default function FlyoutMenu({ id, icon, label, menuItems, isOpen, showTopDivider }) {
  return (

    <PopupState variant="popover" popupId={id}>
      {(popupState) => (
        <div
          className={`${
            isOpen ? "w-full" : "w-fit"
          } items-center justify-stretch rounded-md cursor-pointer`}
        >
        {showTopDivider && <div className='w-[80%] mx-auto my-0 border-t-[2px] border-slate-400 mt-[25px] mb-[20px] pt-[25px]'>
        </div>}
          <Button
            variant={isOpen ? "contained" : ""}
            {...bindHover(popupState)}
            className={`${
              isOpen ? "w-[210px] justify-start pl-[22px]" : "justify-center"
            } capitalize bg-inherit flex items-center rounded-md hover:bg-white text-black`}
            disableElevation={true}
          >
            {icon}
            <span
              className={`${!isOpen && "hidden"} font-normal origin-left duration-200 ml-7`}
            >
              {label}
            </span>
          </Button>
          <CustomPopUpMenu menuItems={menuItems} popupState={popupState} />
        </div>
      )}
    </PopupState>
  );
}
